import store from "../init/store.js";
export function getRecord() {
  const { record } = store.getState().crew;
  /*
   quickBattleWins: 0,
   quickBattleLosses: 0,

   fullteamBattleWins: 0,
   fullteamBattleLosses: 0,

   openBattleWins: 0,
   openBattleLosses: 0,
   */

  //Add some computed values from our known Wins/Losses
  const totalWins =
    record.quickBattleWins + record.fullteamBattleWins + record.openBattleWins;
  const totalLosses =
    record.quickBattleLosses +
    record.fullteamBattleLosses +
    record.openBattleLosses;
  const totalBattles = totalWins + totalLosses;

  return {
    ...record,
    totalWins,
    totalLosses,
    totalBattles
  };
}



// WEBPACK FOOTER //
// ./src/b5-unlocks/getUserBattleRecord.js